import { removeAndReplaceAmpersand } from "./utilities";

/**
 * Get the URL of the profile page and call the encodeURL to encode the URL
 * @id the id of the user defaults to 0
 * @value the name of the profile page
 * @returns returns the encoded URI
 */
export function encodeProfileURL(value, id = 0) {
  const { REACT_APP_CORPORATE_SITE_PROFILE_BASEURL } = process.env;
  value = removeAndReplaceAmpersand(value);
  value = id === 0 ? value : `${id}/${value}`;
  return encodeURL(REACT_APP_CORPORATE_SITE_PROFILE_BASEURL, value, id);
}

/**
 * Update the query string with the given key & value
 * @param {*} key 
 * @param {*} value 
 */
export function updateQueryString(key, value) {
  let searchParams = new URLSearchParams(window.location.search);
  searchParams.set(key, value);
  let newRelativePathQuery =
    window.location.pathname + "?" + searchParams.toString();
  window.history.pushState(null, "", newRelativePathQuery);
}

function encodeURL(url, value) {
  // Encode the URL
  url = encodeURI(`${url}/${value}`);
  let encodedUrl = new URL(url);
  // Add a trailing slash if one doesn't already exist
  encodedUrl.pathname += encodedUrl.pathname.endsWith("/") ? "" : "/";
  return encodedUrl; 
}
